import 'css-chunksrc/client/scenes/changePassword/input/styles.scss';export default {
  "input": "_input_xx590_1",
  "invalid": "_invalid_xx590_14"
};